import React, { useState } from "react";
import { useAuth } from "./components/AuthContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import "./styles/App.css";
import "./styles/main.css";
import "./styles/style.css";
import "./styles/global.css"
import LandingPage from "./Pages/LandingPage";
import PatientLoginPage from "./Pages/PatientLoginPage";
import DoctorLoginPage from "./Pages/DoctorLoginPage";
import VisitQueuePage from "./Pages/VisitQueuePage";
import VisitReviewPage from "./Pages/VisitReviewPage";
import RequestAppointment from "./Pages/RequestAppointment";
import UnderConstruction from "./Pages/UnderConstruction";
import AppHeader from "./components/AppHeader";
import DefaultPage from "./Pages/default";
import About from "./Pages/about";
import OurServices from "./Pages/ourservices";
import ContactUs from "./Pages/contactus";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { MeetingProvider, lightTheme } from "amazon-chime-sdk-component-library-react";

import { AppProvider } from "./AppContext";
import InvitePage from "./Pages/InvitePage";
import VedioQueuePage from "./Pages/VedioQueuePage";
import Lobby from "./Pages/patient/Lobby";
import InfoPage from "./Pages/patient/InfoPage"
import { ThemeProvider } from "styled-components";
function App() {
  const { role, setRole, setIsAuthenticated, isAuthenticated } = useAuth();

  return (
     <AppProvider>
       <ThemeProvider theme={lightTheme}> 
    <MeetingProvider>
    <Router>
      <div className="app-shell">
       <AppHeader /> 

        <main >
          <Routes>
            
            <Route path="/" element={<UnderConstruction />} />
            <Route path="/app" element={<DefaultPage />} />
            <Route path="/lander" element={<LandingPage />} />

            <Route path="/about" element={<About />} />

<Route path="/ourservices" element={<OurServices />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/lobby" element={<Lobby />} />
            <Route path="/info"  element={<InfoPage />} />
           
            <Route
              path="/patient-login"
              element={
                isAuthenticated ? (
                  <Navigate to="/queue" replace />
                ) : (
                  <PatientLoginPage />
                )
              }
            />
            <Route
              path="/doctor-login"
              element={<DoctorLoginPage/>}
            />

            <Route
              path="/doctor-dashboard"
              element={
                isAuthenticated ? (
                  <VisitQueuePage  />
                ) : (
                  <Navigate to="/doctor-login" replace />
                )
              }
            />
            <Route
              path="/review"
              element={
                isAuthenticated ? (
                  <VisitReviewPage viewPage />
                ) : (
                  <Navigate to="/doctor-login" replace />
                )
              }
            />
             <Route
              path="/doctor-vedio"
              element={
                isAuthenticated ? (
                  <InvitePage viewPage />
                ) : (
                  <Navigate to="/doctor-login" replace />
                )
              }
            />
             <Route
              path="/doctor-vqueue"
              element={
                isAuthenticated ? (
                  <VedioQueuePage viewPage />
                ) : (
                  <Navigate to="/doctor-login" replace />
                )
              }
            />
            <Route
              path="/request-appointment"
              element={<RequestAppointment replace/>}
            />
          </Routes>
        </main>
{/* 
        <footer className="app-footer">
          <p>
            Secure, simplified review workflow for physicians and care teams.
          </p>
          <p>Support • Privacy • 24/7 availability</p>
        </footer> */}
      </div>
    </Router>
    </MeetingProvider>
     </ThemeProvider>
    </AppProvider>
  );
}

export default App;
